var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-card",
        { staticClass: "no-shadow" },
        [
          _c(
            "v-card-title",
            { staticClass: "ctn_search" },
            [_c("v-spacer")],
            1
          ),
          _c("v-data-table", {
            attrs: {
              headers: _vm.getHeader,
              items: _vm.itemsData,
              loading: _vm.getLoadTable,
              "footer-props": {
                "items-per-page-options": [10],
              },
              "sort-by": ["createdAt"],
              "sort-desc": [true],
              "items-per-page": 10,
              "server-items-length": _vm.totalNumberOfItems,
              options: _vm.pagination,
              "loading-text": "Cargando información ….",
            },
            on: {
              "update:options": function ($event) {
                _vm.pagination = $event
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: `header.name`,
                  fn: function ({ header }) {
                    return [
                      _vm._v(" " + _vm._s(header.text.toUpperCase()) + " "),
                    ]
                  },
                },
                {
                  key: `item.valInit`,
                  fn: function ({ item }) {
                    return [_c("span", [_vm._v(_vm._s(item.valInit))])]
                  },
                },
                {
                  key: `item.valEnd`,
                  fn: function ({ item }) {
                    return [_c("span", [_vm._v(_vm._s(item.valEnd))])]
                  },
                },
                {
                  key: `item.usage`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "num_ind_next",
                          class: _vm.$options.filters.getNotyVal(
                            item.usage,
                            item.limit
                          ),
                        },
                        [_c("b", [_vm._v(_vm._s(item.usage))])]
                      ),
                    ]
                  },
                },
                {
                  key: `item.limit`,
                  fn: function ({ item }) {
                    return [
                      _c("span", { staticClass: "num_ind" }, [
                        _c("b", [_vm._v(_vm._s(item.limit))]),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.profile`,
                  fn: function ({ item }) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(_vm._f("getProfile")(item.profile))),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.createdAt`,
                  fn: function ({ item }) {
                    return [
                      _vm._v(
                        " " + _vm._s(_vm._f("formatDate")(item.createdAt)) + " "
                      ),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }